import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TERMS_OF_SERVICE } from 'domain/valueObjects/Terms/Terms';

const TermsContainer = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    margin: 20px auto;
    max-width: 800px;
    width: 100%;
`;

const ScrollableTerms = styled.div`
    max-height: 400px;
    overflow-y: auto;
    padding: 24px;
    margin-bottom: 16px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 15px;
    text-align: left;
    line-height: 2;
    white-space: pre-line;

    ${mqMin('SP')} {
        font-size: 14px;
    }
`;

const TermsTitle = styled.div`
    font-size: var(--font-medium);
    font-weight: 600;
    text-align: center;
    margin-bottom: 12px;
`;

export const Terms = () => {
    return (
        <TermsContainer>
            <TermsTitle>{TERMS_OF_SERVICE.title}</TermsTitle>
            <ScrollableTerms>
                {TERMS_OF_SERVICE.sections.map((section, index) => (
                    <div key={index}>
                        {section.heading}
                        <br />
                        {section.content}
                        <br />
                        <br />
                    </div>
                ))}
            </ScrollableTerms>
        </TermsContainer>
    );
};
